import { useContext } from 'react';

import type { Unit } from '@dynatrace-sdk/units';

import type { Formatter } from '../../core/types/formatter.js';
import { getFormatter } from '../../core/utils/get-formatter.js';
import { GaugeChartFormatterContext } from '../contexts/GaugeChartFormatterContext.js';

export interface GaugeChartFormatterConfig {
  formatter: Formatter;
  unit?: string | Unit;
}

export const useGaugeChartFormatterContext = (): GaugeChartFormatterConfig => {
  const ctx = useContext(GaugeChartFormatterContext);

  const formatter = getFormatter(ctx.formatter);
  const unit = ctx.unit;

  return {
    formatter,
    unit,
  };
};
